module.exports = "/fonts/halona-picturemark-d-1d3dcf67de510433984f4218cd210f79.svg";